import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material';

@Component({
  selector: 'snackbar-warning',
  templateUrl: 'snackbar-warning.component.html',
  styles: [`
    .sequence-warning {
      color: #e02638;
    }

    .sequence-warning svg {
      position: relative;
      top: 2px;
      fill: #e02638;
      margin-right: 2px;
    }
  `],
})

export class WarningSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) {}
}


// WEBPACK FOOTER //
// ./src/app/shared/snackbars/snackbar-warning/snackbar-warning.component.ts